// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { ListType, TileSize, TileSizeMobile } from '../../_components/ui';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
/**
 * Two-column layout with proper addon support:
 * - Left column (3/4): Uses tiles (Tile components) and ThumbnailsListWithAddons for mobile
 * - Right column (1/4): Uses TextListWithAddons for articles 5+ with addons
 * This maintains consistent addon handling across both columns.
 */
let TeaserBoxInnerGridL4STextList = class TeaserBoxInnerGridL4STextList extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
            tiles: {
                0: TileSize.L
            },
            listOffset: 5,
            listType: ListType.LIST
        };
    }
};
TeaserBoxInnerGridL4STextList.moduleVersion = TeaserBoxVersion['L-4S-text-list'];
TeaserBoxInnerGridL4STextList = __decorate([
    Component({
        name: 'TeaserBoxInnerGridL4STextList'
    })
], TeaserBoxInnerGridL4STextList);
export { TeaserBoxInnerGridL4STextList };
